import {
  Container, Table,
  TableBody,
  TableCell, TableHead,
  TableRow,
} from '@material-ui/core';
import ASBVCell from 'components/asbv-cell';
import { LinkageTag } from 'components/Linkage-tag/linkage-tag';
import TableScrollbar from 'components/table-scrollbar';
import TraitChart from 'components/trait-chart';
import ChartYLabel from 'components/trait-chart/chart-y-label';
import React, { useRef } from 'react';
import { useBreakpoints } from 'utils/use-breakpoints';
import { ASBVSnapshotProps } from './asbv-snapshot-props';
import './asbv-snapshot.scss';

/**
 * Animal details ASBV snapshot section.
 *
 * Displays the ASBVs in a chart.
 * @param props
 */
export const ASBVSnapshot: React.FC<ASBVSnapshotProps> = (props) => {
  const {
    animals,
  } = props;

  const { phone } = useBreakpoints();

  const tableContainerRef = useRef<HTMLDivElement>(null);

  const chartId = `chart-${animals[0]?.id ?? Math.random()}`;

  return (
    <>
      {!phone && (
        <Container className="sg-asbv-snapshot">
          <div>
            <h2>ASBV snapshot</h2>
          </div>
          <div
            className="table__container table-scroll-shadow"
            ref={tableContainerRef}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className="sticky sticky--left th-labels" />
                  {animals[0]?.asbvs?.map((asbv) => (
                    <TableCell
                      key={asbv.name}
                    >
                      <div className="asbv__abbrev">{asbv.name}</div>
                      <div className="asbv__label">{asbv.label}</div>
                      <div className="asbv__uom">({asbv.uom})</div>
                    </TableCell>
                  ))}
                  <TableCell className="sticky sticky--right sticky--no-width" />
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    className="sticky sticky--left"
                  >
                    <ChartYLabel levels={4} />
                  </TableCell>
                  <TableCell
                    className="cell-chart"
                    colSpan={animals[0]?.asbvs.length}
                  >
                    <div className={`chart__container size-${animals[0]?.asbvs.length}`}>
                      <TraitChart
                        id={chartId}
                        asbvs={animals}
                        yAxisLevels={4}
                      />
                    </div>
                  </TableCell>
                  <TableCell className="sticky sticky--right sticky--no-width" />
                </TableRow>
                <TableRow>
                  <TableCell className="sticky sticky--left" />
                  {animals[0]?.asbvs.map((asbv) => (
                    <TableCell
                      key={asbv.name}
                      align="center"
                    >
                      <ASBVCell asbv={asbv} />
                      <div className="data__tag">
                        <LinkageTag
                          accuracyType={asbv.accuracyType}
                          accuracy={asbv.accuracy}
                        />
                      </div>
                    </TableCell>
                  ))}
                  <TableCell className="sticky sticky--right sticky--no-width" />
                </TableRow>
              </TableBody>
            </Table>
          </div>
          <TableScrollbar
            tableRef={tableContainerRef}
            stickyHeaderRef={tableContainerRef}
          />
        </Container>
      )}
    </>
  );
};
